import React, { Component } from "react";
import { Redirect } from "react-router-dom";

class Main extends Component {
  render() {
    const store = window.location.host.split(".")[0];

    // Unified admin dashboard - accessible via 'admin' subdomain only
    // Only username 'vmass' is allowed to access admin dashboard
    if (store === "admin") {
      // Check if logged in user is 'vmass'
      const username = localStorage.getItem("username");
      if (username === "vmass") {
        return <Redirect to="/root/message/dashboards" />;
      } else {
        // Not vmass user - redirect to login
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
          return <Redirect to="/user/login" />;
        }
        // Logged in but not vmass - show alert and redirect
        alert(
          'Bạn không có quyền truy cập trang quản trị admin. Chỉ tài khoản "vmass" mới được phép truy cập.'
        );
        return <Redirect to="/app" />;
      }
    }

    const ROLESETTINGS = localStorage.getItem("roleSettings")
      ? JSON.parse(localStorage.getItem("roleSettings"))
      : null;

    if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_payment = ROLESETTINGS.find(
        (_role) => _role.role_alias === "table_pending_payment"
      );
      if (typeof find_payment !== "undefined") {
        return <Redirect to="/payment" />;
      }
    }

    if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_kitchen = ROLESETTINGS.find(
        (_role) => _role.role_alias === "kitchen"
      );
      if (typeof find_kitchen !== "undefined") {
        return <Redirect to="/kitchen" />;
      }
    }

    if (ROLESETTINGS && ROLESETTINGS.length) {
      const find_cashier = ROLESETTINGS.find(
        (_role) => _role.role_alias === "cashier"
      );
      if (typeof find_cashier !== "undefined") {
        return <Redirect to="/cashier" />;
      }
    }
    if (store === "register") {
      return <Redirect to="/user/register" />;
    }

    return <Redirect to="/app" />;
  }
}
export default Main;
